import { apiClient } from "./apiClient";
import { adminApi } from "./adminApi";

/**
 * `listAll` reuses GET /user/theme/available-features (api/functions/user.py)
 * -- it already returns the full app.FeatureFlags catalog, just without an
 * admin-specific wrapper; good enough for a read-only list. `setEnabled`
 * reuses the real POST /management/feature-flags.
 *
 * Gradual rollout, A/B comparison and a per-flag changelog are now real:
 *   - updateRollout hits POST /management/feature-flags/rollout with whichever of
 *     rollout_percentage/ab_test_active is being changed (the other can be
 *     omitted).
 *   - abComparison hits GET /management/feature-flags/{feature_name}/ab-comparison,
 *     which compares real app.FeatureUsageAnalytics completion/abandonment
 *     between users currently bucketed on vs. off by rollout_percentage --
 *     this is a usage-outcomes comparison, NOT a true randomized A/B test
 *     engine, and is presented that way in the UI.
 *   - changeLog hits GET /management/feature-flags/{feature_name}/changelog.
 */
export const featureFlagApi = {
  listAll: () => apiClient.get("/user/theme/available-features").then((r) => r.data),
  setEnabled: (featureName, enabled) => adminApi.updateFeatureFlag(featureName, enabled),

  updateRollout: (featureName, { rolloutPercentage, abTestActive } = {}) =>
    apiClient
      .post("/management/feature-flags/rollout", {
        feature_name: featureName,
        ...(rolloutPercentage !== undefined && rolloutPercentage !== null ? { rollout_percentage: rolloutPercentage } : {}),
        ...(abTestActive !== undefined && abTestActive !== null ? { ab_test_active: abTestActive } : {}),
      })
      .then((r) => r.data),

  abComparison: (featureName) =>
    apiClient.get(`/management/feature-flags/${encodeURIComponent(featureName)}/ab-comparison`).then((r) => r.data),

  changeLog: (featureName) =>
    apiClient.get(`/management/feature-flags/${encodeURIComponent(featureName)}/changelog`).then((r) => r.data),
};
